/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactDOMServer from "react-dom/server";
import maplibregl from "maplibre-gl";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";
import { set_value_layer } from "../../App/actions/layerActions";
import { get_sini_data } from "../../App/actions/get_sini_data";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import uuid from "../../App/validation/uuid";
import domain_list from "../../Data/domain_list";

/*CONST*/

const LAYER_GPS = ({
  auth,
  layer,
  properties,
  get_sini_data,
  set_value_sini,
  set_value_layer,
  set_value_properties,
  license_reducer,
}) => {
  const [modal_sini_trigger, set_modal_sini_trigger] = useState(false);

  useEffect(() => {
    const { map_object } = layer;

    if (map_object) {
      const on_render_and_fly = () => {
        on_render();
        on_fly();
      };

      if (!map_object.isStyleLoaded()) {
        map_object.once("styledata", on_render_and_fly);
      } else {
        on_render_and_fly();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties.basemap_used, layer.gps_object?.uuid]);

  const toggle_sini_trigger = () => {
    set_modal_sini_trigger(!modal_sini_trigger);
  };

  const trigger_sini = () => {
    set_value_properties({
      key: "sini_data_mode",
      value: "Site Analysis",
    });

    //cek lisensi di sini

    on_remove_marker();
    const { domain } = auth;
    const { gps_object } = layer;
    const show_survey_1 = domain_list?.[domain]?.show_survey_1;
    const longitude = gps_object?.longitude;
    const latitude = gps_object?.latitude;
    const params = {
      request_id: uuid(),
      long: longitude,
      lat: latitude,
      km_rad: 1,
      sini_data_mode: "sini_general",
      show_survey_1,
    };
    get_sini_data(params);
    set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    set_value_sini({
      key: "is_sini_visible",
      value: true,
    });
    set_value_layer({
      key: "statistic_mode",
      value: "sini",
    });
  };

  const on_remove_marker = () => {
    set_modal_sini_trigger(false);
    const { map_object } = layer;
    if (map_object) {
      if (map_object.getLayer("geojson_gps")) {
        map_object.removeLayer("geojson_gps");
      }
      if (map_object.getSource("geojson_gps")) {
        map_object.removeSource("geojson_gps");
      }
    }
    const marker_element = document.getElementById("gps_map");
    if (marker_element) {
      marker_element.remove();
    }
  };

  const on_render = () => {
    const language = localStorage?.language || "ina";

    const { map_object, gps_object } = layer;
    const longitude = gps_object?.longitude;
    const latitude = gps_object?.latitude;
    if (map_object && longitude && latitude) {
      let marker_element = document.getElementById("gps_map");
      if (!marker_element) {
        marker_element = document.createElement("div");
      }
      marker_element.id = "gps_map";
      marker_element.style.position = "absolute";
      marker_element.style.transform = "translate(-50%, -100%)";
      const marker_jsx = (
        <section
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <button
            className="badge button_white outline_black"
            id="gps_title"
            aria-label="GPS title untuk menampilkan status"
          >
            {dict?.["You're here"]?.[language]}
          </button>
          <div
            style={{ width: "2px", height: "25px", backgroundColor: "black" }}
          />
        </section>
      );
      const marker_html = ReactDOMServer.renderToString(marker_jsx);
      marker_element.innerHTML = marker_html;
      const lngLat = new maplibregl.LngLat(longitude, latitude);
      const point = map_object.project(lngLat);
      marker_element.style.left = `${point.x}px`;
      marker_element.style.top = `${point.y}px`;
      map_object.getContainer().appendChild(marker_element);
      const gps_title = document.getElementById("gps_title");
      if (gps_title) {
        gps_title.addEventListener("click", toggle_sini_trigger);
      }
      map_object.on("move", () => {
        const newPoint = map_object.project(lngLat);
        marker_element.style.left = `${newPoint.x}px`;
        marker_element.style.top = `${newPoint.y}px`;
      });
      const geojson_gps = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [longitude, latitude],
            },
            properties: {},
          },
        ],
      };
      if (!map_object.getSource("geojson_gps")) {
        map_object.addSource("geojson_gps", {
          type: "geojson",
          data: geojson_gps,
        });
      } else {
        map_object.getSource("geojson_gps").setData(geojson_gps);
      }
      if (!map_object.getLayer("geojson_gps")) {
        map_object.addLayer({
          id: "geojson_gps",
          source: "geojson_gps",
          type: "circle",
          paint: {
            "circle-radius": 5,
            "circle-color": "#0ca5eb",
            "circle-stroke-width": 2,
            "circle-stroke-color": "#ffffff",
          },
          layout: { visibility: "visible" },
        });
      }
    }
  };

  const on_fly = () => {
    const { map_object, gps_object } = layer;
    const longitude = gps_object?.longitude;
    const latitude = gps_object?.latitude;
    if (map_object && longitude && latitude) {
      map_object.flyTo({
        center: [longitude, latitude],
        speed: 1,
        zoom: 18,
      });
    }
  };

  const language = localStorage?.language || auth.language;
  const { isAuthenticated } = auth;

  const modal_sini_trigger_content = modal_sini_trigger && (
    <Modal
      modalSize="small"
      isOpen={modal_sini_trigger}
      onClose={toggle_sini_trigger}
    >
      <div className="box-body" id="box-body">
        <section className="text_center">
          {isAuthenticated && (
            <>
              <button
                onClick={trigger_sini}
                className="button_big button_white margin_bottom outline_black"
              >
                {dict?.["Try SINI at your location"]?.[language]}
              </button>
              <br />
              <br />
            </>
          )}
          <button
            className="button_big background_red margin_bottom"
            onClick={on_remove_marker}
          >
            {dict?.["Close"]?.[language]}
          </button>
        </section>
      </div>
    </Modal>
  );

  return <main>{modal_sini_trigger_content}</main>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  get_sini_data,
  set_value_sini,
  set_value_layer,
  set_value_properties,
})(LAYER_GPS);
